import { mapFields } from './map-fields';
import { FINANCIAL_PORTAL_TO_YODLEE_PROVIDER_ACCOUNT_MAP } from './constants';

export { mapFields, convertCentsAmountToDollarsAmount } from './map-fields';

/**
 * This file exposes utility functions for transforming FDP-based financial data objects
 * to the old Yodlee format. This is intended as a temporary measure to ease migration since
 * many existing components and logic expect data shaped in the Yodlee way. Long term, we
 * should refactor these components to use the schema/shape defined in supergraph.
 */
export const convertPortalToProviderAccount = (portal, accounts) =>
  mapFields(
    {
      ...portal,
      accounts,
    },
    FINANCIAL_PORTAL_TO_YODLEE_PROVIDER_ACCOUNT_MAP,
  );
